<template>
  <div>
    <b-row>
      <b-col sm="12">
        <InputText title="Nome" field="name" :formName="formName" :required="true" :maxLength="40"
          v-model="categoryProduct.name" :markFormDirty="false" />
      </b-col>
      <b-col sm="12">
        <InputText title="Cor" field="name" :required="false" :maxLength="20" :markFormDirty="false"
          v-model="categoryProduct.color" />
        <Color titulo="Cor" v-model="categoryProduct.color" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button _key="btnSaveProductCategory" type="success" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fas fa-save" size="medium" :clicked="saveProductCategory" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Color from "@nixweb/nixloc-ui/src/component/forms/Color";
import CategoryProduct from "@/components/modules/stock/category-product/CategoryProduct.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "CategoryProductCreateUpdate",
  props: {
    registerInSelect: Boolean,
    value: Object,
  },
  components: { Button, InputText, Color },
  data() {
    return {
      formName: "categoryProductCreateUpdate",
      categoryProduct: new CategoryProduct(),
      urlCreate: "/api/v1/stock/category-product/create",
      urlUpdate: "/api/v1/stock/category-product/update",
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi"]),
    ...mapMutations("generic", [
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    saveProductCategory() {
      if (this.categoryProduct.id) {
        let params = { url: this.urlUpdate, obj: this.categoryProduct };
        this.putApi(params).then((response) => {
          if (response.success && !this.registerInSelect) this.hideModal();
          this.removeLoading(["btnSaveProductCategory"]);
        });
      } else {
        let params = { url: this.urlCreate, obj: this.categoryProduct };
        this.postApi(params).then((response) => {
          if (response.success && !this.registerInSelect) this.hideModal();
          if (response.success && this.registerInSelect) {
            this.$emit("input", {
              id: response.content.id,
              content: response.content.name,
            });
            this.hideVodal(this.formName);;
          }
          this.removeLoading(["btnSaveProductCategory"]);
        });
      }
    },
    update(data) {
      this.categoryProduct = new CategoryProduct();
      this.categoryProduct.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "productCategoryCreate") {
          this.resetValidation(this.formName);
          this.categoryProduct = new CategoryProduct();
        }
        if (event.name == "productCategoryUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
